const initialState = {
    hello: "I am initial state",
}

export const rootReducer = (state = initialState) => {
    return state;
}